import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bcddc12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-month-stats" }

import { endOfMonth, startOfMonth } from 'date-fns'
  import { toRefs } from 'vue'

  import StatChart from '@/components/Common/StatsChart/index.vue'
  import { ISport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'

  interface Props {
    sports: ISport[]
    user: IUserProfile
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    sports: null,
    user: null
  },
  setup(__props: any) {

const props = __props as {
    sports: ISport[]
    user: IUserProfile
  }

  

  const { sports, user } = toRefs(props)
  const date = new Date()
  const chartParams = {
    duration: 'week',
    start: startOfMonth(date),
    end: endOfMonth(date),
  }
  const selectedSportIds = props.sports.map((sport) => sport.id)

return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('dashboard.THIS_MONTH')), 1)
      ]),
      content: _withCtx(() => [
        _createVNode(StatChart, {
          sports: _unref(sports),
          user: _unref(user),
          "chart-params": chartParams,
          "displayed-sport-ids": _unref(selectedSportIds),
          "hide-chart-if-no-data": true
        }, null, 8, ["sports", "user", "displayed-sport-ids"])
      ]),
      _: 1
    })
  ]))
}
}

})